import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Video, Users, Building2 } from "lucide-react";
import { AdaptiveMediaFrame } from "@/components/AdaptiveMediaFrame";

const fmt = (iso) => { if (!iso) return ""; try { return new Date(iso).toLocaleString("en-PH", { timeZone: "Asia/Manila", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return iso; } };

export function EventCard({ ev }) {
  return (
    <Link to={`/event/${ev.id}`} data-testid={`event-card-${ev.id}`} className="group block bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-md transition-shadow">
      {/* PROTECTED MEDIA — no event-type/status/platform labels over the uploaded poster */}
      <AdaptiveMediaFrame
        src={ev.cover_image}
        alt={ev.title}
        policy="preservation"
        tone="light"
        context="card"
        naturalCard
        rounded=""
        data-testid={`event-card-media-${ev.id}`}
        fallback={
          <div className="w-full h-full flex items-center justify-center" data-testid={`event-card-placeholder-${ev.id}`}>
            <Calendar className="h-12 w-12 text-[#C79A3B]/70" />
          </div>
        }
      />
      <div className="p-4">
        <div className="flex flex-wrap items-center gap-1.5 mb-1.5">
          <span className="inline-block text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#0F2C59]/8 text-[#0F2C59]">{ev.event_type_label}</span>
          {ev.visibility === "NETWORK_ONLY" && <span className="inline-block text-[10px] font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">Network</span>}
        </div>
        <h3 className="font-display font-bold text-slate-900 line-clamp-2 group-hover:text-[#0F2C59]">{ev.title}</h3>
        <div className="mt-2 space-y-1 text-xs text-slate-500">
          <div className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5 text-[#C79A3B]" /> {fmt(ev.start_at)}</div>
          <div className="flex items-center gap-1.5">
            {ev.is_online ? <><Video className="h-3.5 w-3.5 text-[#C79A3B]" /> {ev.event_format_label}</> : <><MapPin className="h-3.5 w-3.5 text-[#C79A3B]" /> {[ev.city, ev.province].filter(Boolean).join(", ") || ev.venue || "—"}</>}
          </div>
          {(ev.developer_name || ev.project_name) && <div className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5 text-slate-400" /> {[ev.project_name, ev.developer_name].filter(Boolean).join(" · ")}</div>}
        </div>
        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between">
          <div className="flex items-center gap-2 min-w-0">
            {ev.organizer?.avatar && <img src={ev.organizer.avatar} alt="" className="h-6 w-6 rounded-full object-cover" />}
            <span className="text-xs text-slate-600 truncate">{ev.organizer?.name}</span>
          </div>
          <span className="text-xs text-slate-400 flex items-center gap-1 shrink-0"><Users className="h-3.5 w-3.5" /> {ev.rsvp_count}</span>
        </div>
      </div>
    </Link>
  );
}
